import { Component, input, signal, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';

export interface DropdownOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'htx-dropdown-field',
  imports: [ReactiveFormsModule, NgClass, IconComponent],
  templateUrl: './dropdown-field.component.html',
  styleUrl: './dropdown-field.component.scss'
})
export class DropdownFieldComponent implements OnInit {
  private uniqueId = Math.random().toString(36).substring(2, 11);

  /** FormControl instance for managing the dropdown's value and validation state */
  ctrl = input.required<AbstractControl>();

  /** Label text displayed above the dropdown field */
  label = input<string>();

  /** Whether to display a required indicator (*) next to the label */
  required = input<boolean>(false);

  /** Array of dropdown options */
  options = input.required<DropdownOption[]>();

  /** Placeholder text when no option is selected */
  placeholder = input<string>('Select an option');

  isOpen = signal<boolean>(false);

  ngOnInit(): void {
    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      const element = event.target as HTMLElement;
      if (!element.closest(`[data-id="${this.getUniqueId()}"]`)) {
        this.isOpen.set(false);
      }
    });
  }

  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }

  getUniqueId(): string {
    return this.uniqueId;
  }

  getSelectedLabel(): string {
    const selectedValue = this.getControl().value;
    if (!selectedValue) return this.placeholder();

    const option = this.options().find(opt => opt.value === selectedValue);
    return option ? option.label : this.placeholder();
  }

  toggleDropdown(): void {
    if (!this.getControl().disabled) {
      this.isOpen.set(!this.isOpen());
    }
  }

  selectOption(option: DropdownOption): void {
    if (!option.disabled) {
      this.getControl().setValue(option.value);
      this.isOpen.set(false);
    }
  }
}
